import { usageDetails, usageDetailsProps } from '@/api/server/point/read';
import { useState, useEffect, useRef, Fragment } from 'react';

import { Button } from '@mui/material';
import Ptx from '@/common/i18nType/PtxType';
import PayMethod from '@/common/i18nType/PayMethod';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorRes from '@/api/server/ErrorRes';
import { SFPalette } from '@/lib/color';
import Stack from '@mui/material/Stack';

type usageDetailsReturnProps = {
  totCnt: string;
  list: usageDetailsListReturnProps;
};
type usageDetailsListReturnProps = {
  pay_method: string;
  pnt_ledger_id: string;
  point_amt: string;
  ptx_type: string;
  reg_dt: string;
};

export default function HistoryList() {
  const [list, setList] = useState<usageDetailsListReturnProps[]>([]);
  const totCnt = useRef('0');
  useEffect(() => {
    (async () => {
      const payload: usageDetailsProps = {};
      const re = await usageDetails(payload);

      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setList(re.data.list);
      totCnt.current = re.data.totCnt ?? '0';
    })();
    return () => {};
  }, []);
  return (
    <>
      total: {totCnt.current}
      <br />
      {list.length > 0
        ? list.map((item: usageDetailsListReturnProps) => (
            <Fragment key={item.pnt_ledger_id}>
              <List>
                <ListItemButton
                  sx={{
                    px: 0,
                    borderBottom: `1px solid ${SFPalette.lightGrey1}`,
                  }}
                >
                  <Box width="100%">
                    <Typography color={SFPalette.lightGrey2} variant="subtitle2" mb={0.5}>
                      {item.reg_dt}
                    </Typography>
                    <Stack direction="row" justifyContent="space-between" mb={0.5}>
                      <Typography color={SFPalette.black} variant="subtitle2">
                        결제종류: <Ptx ptx={item.ptx_type} /> <br />
                        결제수단: <PayMethod pay={item.pay_method} />
                      </Typography>
                      <Typography color={SFPalette.shuffleColor} variant="subtitle2">
                        {item.point_amt}원
                      </Typography>
                    </Stack>
                  </Box>
                </ListItemButton>
              </List>
            </Fragment>
          ))
        : ''}
    </>
  );
}
